import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import radio from './radio.js'
import wrapper from './wrapper.js'

export default contract({
  radio: array([
    radio
  ]),
  wrapper: array([
    wrapper
  ])
})